module.exports = __webpack_public_path__ + "img/SU_KIKE.22372504.png";